import type { ReactElement } from 'react'

type Props = {
  children: ReactElement | ReactElement[]
}

const FormWrapper = ({ children, ...rest }: Props) => {
  return <main {...rest}>{children}</main>
}

export default FormWrapper
